// @flow
import { Record } from 'immutable';
import SpotInventory from '../domain/SpotInventory';
import {
  FETCH_SPOT_INVENTORY,
  FETCH_SPOT_INVENTORY_FAILED,
  FETCH_SPOT_INVENTORY_SUCCESS,
} from '../actions/spotActions';

export type SpotInventoryState = {
  fetching: boolean;
  error: ?Object;
  inventory: SpotInventory[];
  spotsToSell: number;
  spotsSold: number;
}

export const InitialState = Record({
  fetching: false,
  error: {},
  inventory: [],
  spotsToSell: 0,
  spotsSold: 0,
});

export default (state: Record<SpotInventoryState> = new InitialState(), action: Object) => {
  const spotsToSell = action.inventory ? action.inventory.map(s => s.spotsToSell).reduce((a, b) => a + b, 0) : 0;
  const spotsSold = action.inventory ? action.inventory.map(s => s.spotsSold).reduce((x, acc) => x + acc, 0) : 0;

  switch (action.type) {
    case FETCH_SPOT_INVENTORY:
      return state.set('fetching', true)
                  .set('error', undefined)
                  .set('inventory', []);
    case FETCH_SPOT_INVENTORY_SUCCESS:
      return state.set('fetching', false)
                  .set('error', undefined)
                  .set('inventory', action.inventory)
                  .set('spotsToSell', spotsToSell)
                  .set('spotsSold', spotsSold);
    case FETCH_SPOT_INVENTORY_FAILED:
      return state.set('fetching', false)
                  .set('error', action.error)
                  .set('inventory', []);
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/statsradio/modules/spots/reducers/spotInventoryReducer.js